import React, { FC } from 'react'
import { type FeedData } from 'pages/native/userFeed/types'

import { StartTimeInfo } from './components/StartTimeInfo/StartTimeInfo'
import { ArticleInfo } from './components/ArticleInfo/ArticleInfo'
import { ArticleThumbnail } from './components/LiveStreamThumbnail/ArticleThumbnail'
import { FooterInfo } from './components/FooterInfo/FooterInfo'

import classes from './ArticleItem.module.scss'

type ArticleItemProps = {
  item: FeedData
}

export const ArticleItem: FC<ArticleItemProps> = ({ item }) => {
  return (
    <div className={classes.Container}>
      <div className={classes.Body}>
        <ArticleThumbnail imgSrc={item.thumbnailImageUrl} />
        <div className={classes.Info}>
          <StartTimeInfo startTime={item.startTime || item.publishedAt} />
          <ArticleInfo title={item.title} />
        </div>
      </div>
      <FooterInfo game={item} />
    </div>
  )
}
